// useIdleTimer.js
import { useEffect, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const useIdleTimer = (timeout = 900000) => {
  const timerId = useRef(null);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const resetTimer = () => {
    if (timerId.current) {
      clearTimeout(timerId.current);
    }
    timerId.current = setTimeout(async () => {
      // Inactivity detected: log out the user and redirect to login
      try {
        await logout(); // Firebase logout
        navigate("/login");
      } catch (error) {

        navigate("/login");
      }
    }, timeout);
  };

  useEffect(() => {
    // List of events that represent activity
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "touchmove",
      "scroll",
    ];

    // Reset timer on any of these events
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Start the timer when the component mounts
    resetTimer();

    // Cleanup event listeners on unmount
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []); // Empty dependency array: run once on mount
};

export default useIdleTimer;
